import React from 'react';
import PropTypes from 'prop-types';

const FormInputIcon = React.forwardRef((props, ref) => {
  const { icon, loading } = props;

  // TODO use a better loader
  if (loading) {
    return (
      <div className="icon-wrapper">
        <div className="input-icon">
          <i className="zmdi zmdi-settings zmdi-hc-spin" style={{ color: '#2196F3', fontSize: '18px' }} />
        </div>
      </div>
    );
  }

  if (!icon) {
    return null;
  }

  return (
    <div className="icon-wrapper" ref={ref}>
      <div className="input-icon">
        <i className={`zmdi zmdi-${icon} zmdi-hc-2x ${icon}-icon`} />
      </div>
    </div>
  );
});

FormInputIcon.defaultProps = {
  icon: false,
  loading: false,
};

FormInputIcon.propTypes = {
  icon: PropTypes.string,
  loading: PropTypes.bool,
};

export default FormInputIcon;
